import { useKeycloak } from '@react-keycloak/web'
import PropTypes from 'prop-types'

const AuthorizedApp = (props) => {
    const { keycloak, initialized } = useKeycloak()

    const kcRoles = keycloak?.tokenParsed?.user_types?.length ? keycloak?.tokenParsed?.user_types : ['/wp']
    const hasAllRoles = () =>
        initialized && props.roles?.every((r) => kcRoles?.includes(r))

    if (!props?.roles) {
        return <div>Nie masz dostępu do tego zasobu</div>
    }

    return hasAllRoles() ? props.children : <></>
}

AuthorizedApp.propTypes = {
    children: PropTypes.any.isRequired, //@komponent do wyświetlenia
    roles: PropTypes.array.isRequired, //@tablica ról oczekiwanych
    forbidden: PropTypes.any, //@ komponent wyświetlany gdy użytkownik nie ma dostępu (opcjonalnie)
}

export default AuthorizedApp
